import { render } from "./pdf.vue?vue&type=template&id=40fe2c18"
import script from "./pdf.vue?vue&type=script&lang=js"
export * from "./pdf.vue?vue&type=script&lang=js"
script.render = render

export default script